module.exports = __webpack_public_path__ + "img/wolf_5.29d7ca1a.jpg";